module.exports = __webpack_public_path__ + "img/um.a3f2efe2.svg";